export default {
    // Globally available user object
    user: null,
    token: null,
}